import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HotRank from './components/HotRank';
import Collections from './components/Collections';
import TopicWall from './components/TopicWall';
import Feed from './components/Feed';
import Materials from './components/Materials';
import Guide from './components/Guide';
import Faq from './components/Faq';
import Cta from './components/Cta';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <HotRank />
        <Collections />
        <TopicWall />
        <Feed />
        <Materials />
        <section id="guide" className="scroll-mt-20">
          <Guide />
        </section>
        <Faq />
        <Cta />
      </main>
      <Footer />
    </div>
  );
}